module.exports = __webpack_public_path__ + "img/F5-2A.097f3cfc.png";